import SignIn from './SignIn'
import enhance from './SignIn.enhancer'

export default enhance(SignIn)



// WEBPACK FOOTER //
// ./src/routes/public/Login/components/SignIn/index.js